import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M15.28,6.94,13.22,9a.75.75,0,0,1-1.06,0L10.09,6.94a.78.78,0,0,1-.16-.82.75.75,0,0,1,.7-.46h1a4.62,4.62,0,1,0-.41,5.27.76.76,0,0,1,1.06-.1.75.75,0,0,1,.1,1.06,6.14,6.14,0,1,1,.92-6.23h1.47a.75.75,0,0,1,.53,1.28Z';
const draw24px =
  'M23.36,11l-2.83,2.83a.75.75,0,0,1-1.06,0L16.64,11A.75.75,0,0,1,17.7,10l1.53,1.53a7.74,7.74,0,1,0-1.74,5.42.75.75,0,0,1,1.05-.1.76.76,0,0,1,.11,1.06,9.26,9.26,0,1,1,2.09-6.35L22.3,10A.75.75,0,0,1,23.36,11Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const ArrowRotateIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'arrowRotate'),
) as IconWithRender;

ArrowRotateIcon.displayName = 'ArrowRotateIcon';
ArrowRotateIcon.propTypes = Icon.propTypes;
ArrowRotateIcon.renderIcon = (props) => <ArrowRotateIcon {...props} />;
export default ArrowRotateIcon;
